const FOptica = [
  {
    id: 1,
    megas: "20",
    titulomeg: "Megas",
    precio: "$290",
    tiempo: " /al mes",
    incluye: ["Servicio de fibra óptica", "Internet ilimitado"],
    titleButton: "Me interesa",
    folioPaquete: "Folio de inscripción: 2394047",
    hrefButton:
      "https://api.whatsapp.com/send?phone=+527731633306&text=Hola me interesa el paquete de 20 megas Fibra Óptica",
    styleCardHeader: [
      {
        id: 1,
        styleHeader: "w-full md:h-24 bg-viking rounded-t-lg",
        styleTextHead: "text-white text-7xl font-bold text-center p-1",
        styleMeg: "text-lg",
      },
    ],
    styleBodyCard: [
      {
        id: 1,
        styleContPrice:
          "md:w-72 p-3 text-center bg-cerulean text-white rounded-lg",
        styleTextPrice: "text-4xl font-bold",
        styleMes: "text-lg",
        styleItemIcon: "text-viking",
      },
    ],
    styleFooter: [
      {
        id: 1,
        styleButton:
          "bg-viking text-white py-2 xl:w-80 sm:w-52 text-xl text-center font-bold rounded-lg",
      },
    ],
  },
  {
    id: 2,
    megas: "30",
    titulomeg: "Megas",
    precio: "$348",
    tiempo: " /al mes",
    incluye: ["Servicio de fibra óptica", "Internet ilimitado"],
    titleButton: "Me interesa",
    folioPaquete: "Folio de inscripción: 2394169",
    hrefButton:
      "https://api.whatsapp.com/send?phone=+527731633306&text=Hola me interesa el paquete de 30 megas Fibra Óptica",
    styleCardHeader: [
      {
        id: 1,
        styleHeader: "w-full md:h-24 bg-viking rounded-t-lg",
        styleTextHead: "text-white text-7xl font-bold text-center p-1",
        styleMeg: "text-lg",
      },
    ],
    styleBodyCard: [
      {
        id: 1,
        styleContPrice:
          "md:w-72 p-3 text-center bg-cerulean text-white rounded-lg",
        styleTextPrice: "text-4xl font-bold",
        styleMes: "text-lg",
        styleItemIcon: "text-viking",
      },
    ],
    styleFooter: [
      {
        id: 1,
        styleButton:
          "bg-viking text-white py-2 xl:w-80 sm:w-52 text-xl text-center font-bold rounded-lg",
      },
    ],
  },
  {
    id: 3,
    megas: "50",
    titulomeg: "Megas",
    precio: "$406",
    tiempo: " /al mes",
    incluye: ["Servicio de fibra óptica", "Internet ilimitado"],
    titleButton: "Me interesa",
    folioPaquete: "Folio de inscripción: 2394192",
    hrefButton:
      "https://api.whatsapp.com/send?phone=+527731633306&text=Hola me interesa el paquete de 50 megas Fibra Óptica",
    styleCardHeader: [
      {
        id: 1,
        styleHeader: "w-full md:h-24 bg-viking rounded-t-lg",
        styleTextHead: "text-white text-7xl font-bold text-center p-1",
        styleMeg: "text-lg",
      },
    ],
    styleBodyCard: [
      {
        id: 1,
        styleContPrice:
          "md:w-72 p-3 text-center bg-cerulean text-white rounded-lg",
        styleTextPrice: "text-4xl font-bold",
        styleMes: "text-lg",
        styleItemIcon: "text-viking",
      },
    ],
    styleFooter: [
      {
        id: 1,
        styleButton:
          "bg-viking text-white py-2 xl:w-80 sm:w-52 text-xl text-center font-bold rounded-lg",
      },
    ],
  },
  {
    id: 4,
    megas: "75",
    titulomeg: "Megas",
    precio: "$464",
    tiempo: " /al mes",
    incluye: ["Servicio de fibra óptica", "Internet ilimitado"],
    titleButton: "Me interesa",
    folioPaquete: "Folio de inscripción: 2394216",
    hrefButton:
      "https://api.whatsapp.com/send?phone=+527731633306&text=Hola me interesa el paquete de 75 megas Fibra Óptica",
    styleCardHeader: [
      {
        id: 1,
        styleHeader: "w-full md:h-24 bg-viking rounded-t-lg",
        styleTextHead: "text-white text-7xl font-bold text-center p-1",
        styleMeg: "text-lg",
      },
    ],
    styleBodyCard: [
      {
        id: 1,
        styleContPrice:
          "md:w-72 p-3 text-center bg-cerulean text-white rounded-lg",
        styleTextPrice: "text-4xl font-bold",
        styleMes: "text-lg",
        styleItemIcon: "text-viking",
      },
    ],
    styleFooter: [
      {
        id: 1,
        styleButton:
          "bg-viking text-white py-2 xl:w-80 sm:w-52 text-xl text-center font-bold rounded-lg",
      },
    ],
  },
  {
    id: 5,
    megas: "90",
    titulomeg: "Megas",
    precio: "$464",
    tiempo: " /al mes",
    incluye: ["Servicio de fibra óptica", "Internet ilimitado"],
    titleButton: "Me interesa",
    folioPaquete: "Folio de inscripción: 2394282",
    hrefButton:
      "https://api.whatsapp.com/send?phone=+527731633306&text=Hola me interesa el paquete de 90 megas Fibra Óptica",
    styleCardHeader: [
      {
        id: 1,
        styleHeader: "w-full md:h-24 bg-viking rounded-t-lg",
        styleTextHead: "text-white text-7xl font-bold text-center p-1",
        styleMeg: "text-lg",
      },
    ],
    styleBodyCard: [
      {
        id: 1,
        styleContPrice:
          "md:w-72 p-3 text-center bg-cerulean text-white rounded-lg",
        styleTextPrice: "text-4xl font-bold",
        styleMes: "text-lg",
        styleItemIcon: "text-viking",
      },
    ],
    styleFooter: [
      {
        id: 1,
        styleButton:
          "bg-viking text-white py-2 xl:w-80 sm:w-52 text-xl text-center font-bold rounded-lg",
      },
    ],
  },
  {
    id: 6,
    megas: "120",
    titulomeg: "Megas",
    precio: "$696",
    tiempo: " /al mes",
    incluye: ["Servicio de fibra óptica", "Internet ilimitado"],
    titleButton: "Me interesa",
    folioPaquete: "Folio de inscripción: 2394299",
    hrefButton:
      "https://api.whatsapp.com/send?phone=+527731633306&text=Hola me interesa el paquete de 120 megas Fibra Óptica",
    styleCardHeader: [
      {
        id: 1,
        styleHeader: "w-full md:h-24 bg-viking rounded-t-lg",
        styleTextHead: "text-white text-7xl font-bold text-center p-1",
        styleMeg: "text-lg",
      },
    ],
    styleBodyCard: [
      {
        id: 1,
        styleContPrice:
          "md:w-72 p-3 text-center bg-cerulean text-white rounded-lg",
        styleTextPrice: "text-4xl font-bold",
        styleMes: "text-lg",
        styleItemIcon: "text-viking",
      },
    ],
    styleFooter: [
      {
        id: 1,
        styleButton:
          "bg-viking text-white py-2 xl:w-80 sm:w-52 text-xl text-center font-bold rounded-lg",
      },
    ],
  },
  {
    id: 7,
    megas: "150",
    titulomeg: "Megas",
    precio: "$812",
    tiempo: " /al mes",
    incluye: ["Servicio de fibra óptica", "Internet ilimitado"],
    titleButton: "Me interesa",
    folioPaquete: "Folio de inscripción: 2394316",
    hrefButton:
      "https://api.whatsapp.com/send?phone=+527731633306&text=Hola me interesa el paquete de 150 megas Fibra Óptica",
    styleCardHeader: [
      {
        id: 1,
        styleHeader: "w-full md:h-24 bg-viking rounded-t-lg",
        styleTextHead: "text-white text-7xl font-bold text-center p-1",
        styleMeg: "text-lg",
      },
    ],
    styleBodyCard: [
      {
        id: 1,
        styleContPrice:
          "md:w-72 p-3 text-center bg-cerulean text-white rounded-lg",
        styleTextPrice: "text-4xl font-bold",
        styleMes: "text-lg",
        styleItemIcon: "text-viking",
      },
    ],
    styleFooter: [
      {
        id: 1,
        styleButton:
          "bg-viking text-white py-2 xl:w-80 sm:w-52 text-xl text-center font-bold rounded-lg",
      },
    ],
  },
  {
    id: 8,
    megas: "200",
    titulomeg: "Megas",
    precio: "$986",
    tiempo: " /al mes",
    incluye: ["Servicio de fibra óptica", "Internet ilimitado"],
    titleButton: "Me interesa",
    folioPaquete: "Folio de inscripción: 2394337",
    hrefButton:
      "https://api.whatsapp.com/send?phone=+527731633306&text=Hola me interesa el paquete de 200 megas Fibra Óptica",
    styleCardHeader: [
      {
        id: 1,
        styleHeader: "w-full md:h-24 bg-viking rounded-t-lg",
        styleTextHead: "text-white text-7xl font-bold text-center p-1",
        styleMeg: "text-lg",
      },
    ],
    styleBodyCard: [
      {
        id: 1,
        styleContPrice:
          "md:w-72 p-3 text-center bg-cerulean text-white rounded-lg",
        styleTextPrice: "text-4xl font-bold",
        styleMes: "text-lg",
        styleItemIcon: "text-viking",
      },
    ],
    styleFooter: [
      {
        id: 1,
        styleButton:
          "bg-viking text-white py-2 xl:w-80 sm:w-52 text-xl text-center font-bold rounded-lg",
      },
    ],
  },
];

export default FOptica;
